import React, { useState, useEffect } from 'react';
//import programdata from '../programdata/db.json';
// rrd import
import { useLoaderData } from 'react-router-dom';

// component import
import Footer from '../components/Footer';
import ProgramDetailsView from '../components/ProgramDetailsView';
import imgPrograms from '../assets/programs.jpg';
import img1 from '../assets/image1.webp';
import img8 from '../assets/image8.webp';
import '../styles/hero.css';

const UndergraduatePrograms = () => {
    const programs = useLoaderData();
    console.log("Data:", programs);
  const [expandedId, setExpandedId] = useState(null);
  const images = [imgPrograms, img1, img8];
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setCurrent((c) => (c + 1) % images.length), 4200);
    return () => clearInterval(id);
  }, [images.length]);

  return (
    <>
      <div className="page-hero programs-hero">
        {images.map((img, i) => (
          <div
            key={i}
            className={`bg-layer ${i === current ? 'active' : ''}`}
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}
          <button className="hero-nav prev" onClick={() => setCurrent((current - 1 + images.length) % images.length)} aria-label="Previous image">‹</button>
          <button className="hero-nav next" onClick={() => setCurrent((current + 1) % images.length)} aria-label="Next image">›</button>
          <div className="page-hero-inner">
            <h2 className='u-title title'>Programs we offer</h2>
          </div>
          <div className="hero-dots">
            {images.map((_, i) => (
              <button
                key={i}
                className={`hero-dot ${i === current ? 'active' : ''}`}
                onClick={() => setCurrent(i)}
                aria-label={`Go to image ${i + 1}`}
              />
            ))}
          </div>
      </div>
      <div className='course-programs'>

      {programs.undergraduatePrograms.map(program => (
        <div className="pro-link" key={program.id}>
          <div
            className="pro-summary"
            onClick={() => setExpandedId(expandedId === program.id ? null : program.id)}
            style={{ cursor: 'pointer' }}
          >
            <p>{program.program}</p>
            <p><b>Duration</b>: {program.duration}</p>
          </div>

          {expandedId === program.id && (
            <ProgramDetailsView program={program} />
          )}
        </div>
      ))}

      </div>

      <Footer />
    </>
  )
}

export default UndergraduatePrograms

// loader function
export const programsLoader = async () => {
    //const res = await fetch('http://localhost:3000/undergraduatePrograms');
    //const res = programdata;
    //if (!res.ok) {
     //   throw Error("Could not fetch programs");
    //}
    //return programdata;
    //res.json();
    const res = await fetch('/programdata/db.json');

  if (!res.ok) {
    throw Error("Could not fetch programs");
  }

  return await res.json();
}
